<section class="sanofi-userProfilePhoneSection">
  <section class="row mb-3">
    <section class="col-9 d-flex align-items-end">
      <h3 class="font-bold">{{ "profile.phoneSection.title" | cxTranslate }}</h3>
      <h4 class="ml-1 font-bold">{{ "profile.forVerification" | cxTranslate }}</h4>
    </section>
    <section class="col-3">
      <div class="float-right c-link">
        @if (phoneEditIsNotClicked()) {
          <span class="edit-Option" (click)="editPhoneField()">{{ "profile.edit" | cxTranslate }}</span>
          <fa-icon [icon]="faPenToSquare" class="icon"/>
        }
      </div>
    </section>
  </section>
  <section class="container p-0"
           [ngClass]="{
              'margin-Down': phoneEditIsNotClicked(),
              'edited-Fields-Margin-Value': !phoneEditIsNotClicked()
           }"
  >
    @if (phoneEditIsNotClicked()) {
      <section class="row">
        <section class="col-md-12 d-flex align-items-center">
          @if (accountPhoneNumber().length) {
            <span class="inner-Content inner-Content-Font-Color mr-2">{{ accountPhoneNumber() }}</span>
            <div class="sanofi-userProfilePhoneSection__verified d-flex align-items-center p-1 px-3">
              <cx-icon class="sanofi-userProfilePhoneSection__checkIcon p-1 mr-2" [type]="ICON_TYPE.CHECK"/>
              <span class="inner-Content inner-Content-Font-Color text-white py-1">{{ "profile.phoneSection.verified" | cxTranslate }}</span>
            </div>
          }
        </section>
      </section>
    } @else {
      <section class="row mb-3" [formGroup]="phoneForm">
        <section class="col-md-12 c-text-input">
          <label class="mb-3" for="phoneId"> {{ "profile.phoneSection.subtitle" | cxTranslate }}</label>
        </section>
        <section class="col-md-6 c-text-input">
          <input
            placeholder="_ _ _-_ _ _-_ _ _ _"
            type="tel"
            id="{{PHONE_INPUT_ID}}"
            class="form-control text-Field-Styling"
            maxlength="12"
            formControlName="{{PHONE_INPUT_ID}}"
            appPhoneMask
            [class.required]="
              (!phoneForm.get(PHONE_INPUT_ID).value?.length || phoneForm.get(PHONE_INPUT_ID).invalid) &&
              (phoneForm.get(PHONE_INPUT_ID).touched || phoneForm.get(PHONE_INPUT_ID).dirty)
            "
          />

          @if (phoneForm.get(PHONE_INPUT_ID).invalid && (phoneForm.get(PHONE_INPUT_ID).dirty || phoneForm.get(PHONE_INPUT_ID).touched) && phoneForm.get(PHONE_INPUT_ID).value?.length) {
            <cx-form-errors class="text-danger">
              <p>{{ "profile.phoneSection.invalidPhone" | cxTranslate }}</p>
            </cx-form-errors>
          }

          @if ((phoneForm.get(PHONE_INPUT_ID).dirty || phoneForm.get(PHONE_INPUT_ID).touched) && !phoneForm.get(PHONE_INPUT_ID).value?.length) {
            <cx-form-errors class="text-danger">
              <p>{{ "profile.requiredError" | cxTranslate }}</p>
            </cx-form-errors>
          }

          @if (!!mobileErrorMsg()) {
            <div class="text-danger"> {{ mobileErrorMsg() }} </div>
          }

          <span class="sanofi-userProfilePhoneSection__noticeText">{{ "profile.phoneSection.notice" | cxTranslate }}</span>
          <div class="d-flex sanofi-userProfilePhoneSection__noticeText">
            <a class="mr-2" href="https://www.sanofi.com/en/legal-notice">{{ "profile.phoneSection.termsAndConditions" | cxTranslate }}</a>
            <a href="https://www.sanofi.com/en/privacy-and-data-protection">{{ "profile.phoneSection.privacyAndData" | cxTranslate }}</a>
          </div>
        </section>
      </section>
      <section class="row mt-4">
        <section class="col-md-12 d-flex justify-content-start">
          <button class="c-button c-button--secondary mr-2" (click)="cancelPhoneUpdate()">{{ "profile.cancel" | cxTranslate }}</button>
          @if (accountPhoneNumber()) {
            <button class="c-button c-button--primary mr-2"
                    (click)="updatePhoneField()"
                    [disabled]="phoneForm.invalid || phoneForm.get(PHONE_INPUT_ID).value?.length < 12 || !phoneForm.dirty"
            >
              {{ "profile.update" | cxTranslate }}
            </button>
            <button class="c-button c-button--primary"
                    [disabled]="phoneForm.dirty"
                    [ngbPopover]="deletePopupContent"
                    #deletePopup="ngbPopover"
                    [autoClose]="false"
                    triggers="manual"
                    (click)="deletePopup.open()"
                    popoverClass="sanofi-userProfilePhoneSection__removePopup p-3"
            >
              {{ "profile.phoneSection.remove" | cxTranslate }}
            </button>
            <ng-template #deletePopupContent>
              <button class="c-button c-button--secondary mr-3  sanofi-userProfilePhoneSection__popupBtn" (click)="deletePopup.close()">
                {{ "profile.phoneSection.noKeep" | cxTranslate }}
              </button>
              <button class="c-button c-button--primary sanofi-userProfilePhoneSection__popupBtn" (click)="removeMobile(deletePopup)" [disabled]="phoneForm.dirty">
                {{ "profile.phoneSection.yesRemove" | cxTranslate }}
              </button>
            </ng-template>
          } @else {
            <button class="c-button c-button--primary"
                    (click)="updatePhoneField()"
                    [disabled]="phoneForm.invalid || phoneForm.get(PHONE_INPUT_ID).value?.length < 12"
            >
              {{ "profile.phoneSection.addNumberBtn" | cxTranslate }}
            </button>
          }
        </section>
      </section>
    }
  </section>
</section>
